import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PasswordExpiryService {
  isPasswordExpiringSoon(): boolean {
    if (sessionStorage.getItem('passwordExpiryRemindLater') === 'true') {
      return false;
    }
    const expiryDateStr = localStorage.getItem('passwordExpiryDate');
    if (!expiryDateStr) {
      return false;
    }

    const currentDate = new Date();
    const expiryDate = new Date(expiryDateStr);

    const diffDays = Math.ceil((expiryDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24));
    return diffDays > 0 && diffDays <= 7; // Show alert if within 7 days
  }

  hasPasswordExpired(): boolean {
    const expiryDateStr = localStorage.getItem('passwordExpiryDateInMillis');
    if (!expiryDateStr) {
      return false;
    }
    const expiryDate = new Date(Number(expiryDateStr));
    const currentDate = new Date();
    return currentDate >= expiryDate;
  }

  getExpiryDate(): string {
    const expiryDateStr = localStorage.getItem('passwordExpiryDate');
    if (!expiryDateStr) {
      return '';
    }
    return new Date(expiryDateStr).toLocaleDateString();
  }
}
